import { getNumberWithOrdinal } from '../../../redux/modules/shoppingCart/shoppingCart.selectors';
import { deliveryMethod } from '../../../settings/settings';
import styles from './RMDTransactions.module.scss';
import React from 'react';
import { useSelector } from 'react-redux';
import { getUserStateWithholdingRules } from '../../../redux/modules/stateWithholding/stateWithholding.selectors';
import {
  getAllUserFunds,
  getIsRMDSpecialPayee,
} from '../../../redux/modules/UserFunds/userFunds.selectors';
import { getExistingBanksInfo } from '../../../redux/modules/existingBanks/existingBanks.selectors';
import { doesExistingAutomaticsHaveSpecialPayee } from '../../../redux/modules/existingAutomatics/existingAutomatics.selectors';
import {getAllFundsList} from "../../../redux/modules/allFunds/allFunds.selectors";

export const printAgreementType = (agreementType) => {
  return agreementType?.replace('_', ' ');
};

export const printFrequency = (fund) => {
  let date = fund.transferDays;
  const months = fund.transfers?.filter(
    (en) => en.status.enumerationName === 'on'
  );
  const allMonths = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'July',
    'Aug',
    'Sept',
    'Oct',
    'Nov',
    'Dec',
  ];
  date = date.sort((a, b) => a - b);
  return (
    <span>
      Every {months.length === 12 && 'month'}
      {months.length !== 12 &&
        months
          .sort((a, b) => a - b)
          .map((en, index) => (
            <span key={index}>
              {allMonths[en.month]}
              {index !== months.length - 2
                ? index !== months.length - 1 && ', '
                : ' & '}
            </span>
          ))}{' '}
      {date.map((allDays, i) => (
        <span key={i}>
          {i === 0 && <span>on the </span>}
          {getNumberWithOrdinal(allDays)}
          {i !== date.length - 1 && i !== date.length - 2 && <span>, </span>}
          {i === date.length - 2 && <span> and </span>}
        </span>
      ))}
    </span>
  );
};
export const printFromData = (ID, key) => {
  const allFunds = useSelector(getAllUserFunds);
  return allFunds.find((ele) => ele.agreementID === ID)?.[key];
};

export const printToData = (curFund, ID) => {
  const allFunds = useSelector(getAllUserFunds);
  const fundsList = useSelector(getAllFundsList);
  const specialPayee = useSelector(getIsRMDSpecialPayee);
  const allBanks = useSelector(getExistingBanksInfo);
  const fund = allFunds.find((ele) => ele.agreementID === ID);
  const isExchangeToNew = curFund?.deliveryType?.enumerationName === "ExchangeToNew";
  const delivery = deliveryMethod[curFund?.deliveryType?.enumerationName];
  const curBank = allBanks.find(
    (bank) => bank.bankAgreementID === curFund.bankAgreementKey.bankAgreementID
  );

  //In exchange to NEW the target agreementKey returns the rkpCode of the fund so we can can find the fund name
  const exchangeToNewFund = fundsList.filter((ele) => ele.rkpCode === curFund.targetAgreementKey.agreementID);

  return (
    <>

      {isExchangeToNew && curFund.pending && (
        <span>
          <strong className={`${styles['fund-type']} blocked_data`}>
            NON-RETIREMENT / INDIVIDUAL
          </strong>
           <br />
          <span className={`${styles['fund-name']} blocked_data`}>
            {exchangeToNewFund[0]?.name}
          </span>
          <span className={styles['fund-ticker']}>
            {exchangeToNewFund[0]?.ticker}
          </span>
          <span className={styles['new-fund-header']}>
            New
          </span>
        </span>
      )}
      {(!isExchangeToNew || (isExchangeToNew && !curFund.pending)) && (
        <>
          {delivery && (
            <>
              {' '}
              <strong className={styles['deliveryMethod']}>
                {delivery}
              </strong>{' '}
              <br />
            </>
          )}
          {!delivery ? (
            <div className={styles['autosell-from']}>
              <strong className={styles['fund-type']}>
                {printFromData(
                  curFund.targetAgreementKey.agreementID,
                  'displayClassification'
                )?.replace('_', '-')}{' '}
                /{' '}
                {printAgreementType(
                  printFromData(
                    curFund.targetAgreementKey.agreementID,
                    'agreementType'
                  )
                )}
              </strong>
              <br />
              <span className={styles['fund-name']}>
                {printFromData(
                  curFund.targetAgreementKey?.agreementID,
                  'fundName'
                )}
              </span>
              <span className={styles['fund-ticker']}>
                  {printFromData(curFund.targetAgreementKey?.agreementID, 'ticker')}
                </span>
                <span className={styles['fund-ticker']}>
                  {printFromData(curFund.targetAgreementKey?.agreementID, 'agreementNumber')}
                </span>
            </div>
          ) : delivery === 'Mail To' ? (
            <span className="blocked_data">
              {(specialPayee || curFund?.specialPayee) && (
                <span className="blocked_data">Special Payee</span>
              )}
              {!(specialPayee || curFund?.specialPayee) && (
                <span className="blocked_data">
                  {fund?.address?.street1}
                  <span className={`${styles['address-con']} blocked_data`}>
                    {fund?.address?.street2}{' '}
                  </span>{' '}
                  <span className={`${styles['address-con']} blocked_data`}>
                    {fund.address.city}, {fund.address.state} {fund.address.zip}
                  </span>{' '}
                </span>
                )}
            </span>
          ) : (
            <span className={`${styles['directDepositMethod']} blocked_data`}>
              {curBank?.name}
              <br /> {'-  '} {curBank?.bankAccountType}
              <br />
              {curBank?.accountNumber}
            </span>
          )}
          </>
        )}
    </>
  );
};
export const isStateWithholding = (fund) => {
  const stateWithholdingData = useSelector(getUserStateWithholdingRules);
  return (
    stateWithholdingData.percent > 0 &&
    stateWithholdingData.mandatory &&
    ((stateWithholdingData.federalTaxDependent && fund.IRAWithholding > 0) ||
      !stateWithholdingData.federalTaxDependent)
  );
};
